import {
    SET_RESET,
    SET_ERROR,
    SET_LOADING,
    SET_WHY, SET_Slider, SET_GRID, SET_HINT, SET_TOPIC_NEWS, SET_CONTACT, SET_SOCIAL


} from "./mutation_types";
import {
    GET_ALL_NEWS,
    GET_CONTACT_DETAILS,
    GET_GRID, GET_HINT,
    GET_RESET,
    GET_SLIDER, GET_SOCIAL, GET_TOPIC_NEWS,
    GET_WHY,


} from "./action_types";
import {getApi, getWithoutLocalApi} from "../../data/ApiService";
import {GET_NEWS} from "../newsManagement/action_types";
import {SET_NEWS} from "../newsManagement/mutation_types";

export default {
    async [GET_WHY]({commit}, payload) {

        commit(SET_LOADING, true);
        try {
            const response = await getApi('topics/13/page/1/count/100');
            commit(SET_WHY, response);
        } catch (e) {
            commit(SET_ERROR, e.response.message);
        } finally {
            commit(SET_LOADING, false);
        }
    },
    async [GET_SLIDER]({commit}, payload) {

        commit(SET_LOADING, true);
        try {
            const response = await getApi('category/200/page/1/count/100');
            commit(SET_Slider, response);
        } catch (e) {
            commit(SET_ERROR, e.response.message);
        } finally {
            commit(SET_LOADING, false);
        }
    },
    async getMainMenu({commit,state}) {

        commit(SET_LOADING, true);
        try {
            const response = await getApi('menu/1');
            state.mainMenu=response.data;
            return response;
        } catch (e) {
            commit(SET_ERROR, e.response.message);
        } finally {
            commit(SET_LOADING, false);
        }
    },
    async getLightweightBlockMenu({commit,state}) {

        commit(SET_LOADING, true);
        try {
            const response = await getApi('menu/2');
            state.lightweightBlockMenu=response.data;
            return response;
        } catch (e) {
            commit(SET_ERROR, e.response.message);
        } finally {
            commit(SET_LOADING, false);
        }
    },
    async getMaterialHeaderItems({commit,state}) {

        commit(SET_LOADING, true);
        try {
            const response = await getApi('menu/105');
            state.materialHeaderMenu=response.data;
            return response;
        } catch (e) {
            commit(SET_ERROR, e.response.message);
        } finally {
            commit(SET_LOADING, false);
        }
    },
    async getGlassHeaderMenu({commit,state}) {

        commit(SET_LOADING, true);
        try {
            const response = await getApi('menu/3');
            state.glassHeaderMenu=response.data;
            return response;
        } catch (e) {
            commit(SET_ERROR, e.response.message);
        } finally {
            commit(SET_LOADING, false);
        }
    },
    async [GET_GRID]({commit}, payload) {

        commit(SET_LOADING, true);
        try {
            const response = await getApi('categories/8');
            commit(SET_GRID, response);
        } catch (e) {
            commit(SET_ERROR, e.response.message);
        } finally {
            commit(SET_LOADING, false);
        }
    },
    async [GET_HINT]({commit}, payload) {

        commit(SET_LOADING, true);
        try {
            const response = await getApi('banners/9');
            commit(SET_HINT, response);
        } catch (e) {
            commit(SET_ERROR, e.response.message);
        } finally {
            commit(SET_LOADING, false);
        }
    },
    async [GET_TOPIC_NEWS]({commit},payload){

        commit(SET_LOADING,true);
        try{
            const response = await getApi('category/89/page/1/count/3');
            console.log(response);
            commit(SET_TOPIC_NEWS,response);
        }
        catch (e) {
            commit(SET_ERROR,e.response.message);
        }
        finally {
            commit(SET_LOADING,false);
        }
    },
    async [GET_CONTACT_DETAILS]({commit}){

        commit(SET_LOADING,true);
        try{
            const response = await getApi('website/contacts');
            console.log(response);
            commit(SET_CONTACT,response);
        }
        catch (e) {
            commit(SET_ERROR,e.response.message);
        }
        finally {
            commit(SET_LOADING,false);
        }
    },
    async [GET_SOCIAL]({commit}){

        commit(SET_LOADING,true);
        try{
            const response = await getWithoutLocalApi('website/social');
            console.log(response);
            commit(SET_SOCIAL,response);
        }
        catch (e) {
            commit(SET_ERROR,e.response.message);
        }
        finally {
            commit(SET_LOADING,false);
        }
    },
    async [GET_RESET]({commit}) {


        commit(SET_RESET);

    },
};

